import { Directive } from '@angular/core';

@Directive({
    selector: '[nbSuffix]',
    standalone: false
})
export class NbSuffixDirective {
}
